import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class FibreGradeReferenceService extends BaseReferenceService {
  constructor() {
    super('FibreGradeReference');
  }
}
